import axios, { AxiosResponse } from 'axios';
import { prepareJsonRpcRequestData } from '@/common/helpers/prepare-request-data.helper';
import { toError } from '@/common/helpers/error.helper';

interface JsonRpcResponseInterface {
    id: number;
    jsonrpc: string;
    result?: any;
    error?: ErrorResponseInterface;
}

interface ErrorResponseInterface {
    code?: number;
    message?: string;
    data?: {
        type?: string;
        code?: number;
        message?: string;
        messageId?: string;
        userMessage?: string;
    };
}

export class RequestManagerService {
    public static makeRequest(url: string, gmMethod: string, params: object): Promise<any> {
        const data = prepareJsonRpcRequestData(gmMethod, params);
        const method = 'POST';

        return new Promise((resolve, reject) => {
            axios({ method, url, data })
                .then((response: AxiosResponse<JsonRpcResponseInterface>) => {
                    const { result, error } = response.data;

                    if (error) {
                        throw error;
                    }

                    resolve(result);
                })
                .catch((error: any) => {
                    reject(toError(error));
                });
        });
    }
}
